<template>
    <div class="row gapped">
        <span class="text-title"
        >{{ toLocal("group.element_repeats") }}:</span
        >
        <div class="time-select">
            <span class="front-text"> {{ toLocal("mail.every") }} </span>
            <input
                @input="
                (e) =>
                    changeElementInfo(e, element,element, 'repeatTime', 'training_repeats_every')
                "
                @change="saveRequest(element)"
                :maxlength="4"
                placeholder="0"
                :value="repeatTime"
                type="text"
                :class="{ grayed: training_repeats_every == 0 }"
            />

            <CustomDropdown
                class="white-c-dropdown"
                :class="{ grayed: training_repeats_every == 0 }"
                :list="elementRepeatingDD"
                :compareChosen="repeatingTypeObj"
                :options="{
                    closeOnClick: true,
                    checkbox: false,
                    customDDWidth: '150%',
                    customMaxHeight: '300px',
                    initial: repeatingTypeObj
                        ? repeatingTypeObj.short
                        : '',
                    containerClass: 'groups-table-dropdown',
                    searchBar: false,
                    attached: {
                        type: 'repeat',
                        element: element,
                    }
                }"
                @elClicked="changeElementType"
            />
            <span class="front-text">
                {{ toLocal("training_edit.test_questions_or") }}
            </span>
            <div
                class="time-select-btn"
                :class="{ active: training_repeats_every == 0 }"
                @click="clearElementTime('repeat', element)"
            >
                {{ toLocal("group.doesnt_repeat") }}
            </div>
        </div>
    </div>
</template>
<script>
import CustomDropdown from "@/components/layout/elements/CustomDropdown.vue";

export default {
    name: 'TimeRepeatRow',
    props:{
        element:{
            type: Object
        },
        keyLabel:{
            type: String
        }
    },
    components:{
        CustomDropdown
    },
    data() {
        return {
            repeatTime: 0,
            training_repeats_every: 0,
            repeatingTypeObj: {
                    id: 0,
                    name: "generic.days_multiple",
                    short: "generic.days_short",
                },
            elementRepeatingDD: [
                {
                    id: 0,
                    name: "generic.days_multiple",
                    short: "generic.days_short",
                },
                {
                    id: 1,
                    name: "generic.weeks_multiple",
                    short: "generic.weeks_short",
                },
                {
                    id: 2,
                    name: "generic.months_multiple",
                    short: "generic.months_short",
                },
                {
                    id: 3,
                    name: "generic.years_multiple",
                    short: "generic.years_short",
                },
            ],
        };
    },

    mounted() {
        if(this.element && this.element[this.keyLabel]){
            this.repeatTime = this.element[this.keyLabel].training_repeats_every || 0;
            this.training_repeats_every = this.element[this.keyLabel].training_repeats_every || 0;
            const typeId = this.element[this.keyLabel].training_repeats_every_type || 0;
            this.repeatingTypeObj = this.elementRepeatingDD.find(el => el.id == typeId) || this.elementRepeatingDD[0];
        }
    },

    methods: {
       
        changeElementInfo(e, element, info, key, key2) {
            let value = 0;
            if(e){
                value = e.target.value;
                value = value.replace(/[^0-9]/g, '');
                if(isNaN(value) || value === ''){
                    value = 0;
                }
                value = parseInt(value);
            } else {
                // When e is null (called from changeElementType), use local state
                value = key === 'repeatType' ? this.repeatingTypeObj.id : this.repeatTime;
            }
            
            // Update local state
            if(key === 'repeatTime'){
                this.repeatTime = value;
                this.training_repeats_every = value;
            }
            
            // Update element settings
            if(element && element[this.keyLabel]){
                this.$set(element[this.keyLabel], key2, value);
            }
            
            if(e == null){
                this.saveItem(element);
            }
        },
        saveRequest(element){
            this.saveItem(element)
        },
        saveItem(element){
          let settings= {
            'training_repeats_every': this.training_repeats_every,
            'training_repeats_every_type': this.repeatingTypeObj.id,
          }
          this.$set(element, this.keyLabel, settings),
          this.$emit('saveItem', element)
        },
        clearElementTime(type, element) {
           if (type == "repeat") {
                if (element[this.keyLabel].training_repeats_every == 0) return;
                element[this.keyLabel].training_repeats_every = 0;
                element[this.keyLabel].training_repeats_every_type = 0;
                this.repeatTime = 0;
                this.repeatType = 0;
                this.repeatingTypeObj = this.elementRepeatingDD[0];
            }
            this.saveItem(element);
        },
        changeElementType(id, attached) {
            if (attached.type == "repeat") {
                let type = this.elementRepeatingDD.find((el) => el.id == id);
                if(type){
                    this.repeatingTypeObj = type;
                    this.changeElementInfo(
                        null,
                        this.element,
                        this.element,
                        'repeatType',
                        'training_repeats_every_type'
                    );
                }
            } 
        },
    },
};
</script>
<style lang="scss" scoped>
.row {
    display: flex;
    gap: 4px;
    font-size: clamp(12px, 1.2vw, 14px);
    align-items: center;
    .result {
      font-weight: 600;
    }
    &.gapped {
      gap: 16px;
    }
}

.time-select {
  display: flex;
  gap: 8px;
  align-items: center;
  input {
    padding: 4px 2px;
    border-radius: 6px;
    border: 1px solid #b2b2b2;
    text-align: center;
    max-width: 48px;
    font-size: clamp(12px, 1.2vw, 14px);
  }
  .white-c-dropdown {
    border-radius: 6px;
    border: 1px solid #b2b2b2;
    background: #fff;
    color: hsla(0, 0%, 20%, 1);
    width: 90px;
    padding: 3px 10px;
    &:not(.no-padding-no-bg){
        background: white;
        
    }
    .dropdown-initial {
      font-size: clamp(12px, 1.2vw, 14px);
      .white path {
        stroke: hsla(0, 0%, 20%, 1);
      }
    }
  }
}
.time-select-btn {
  user-select: none;
  border-radius: 20px;
  background: #f4f4f4;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
  font-size: clamp(12px, 1.2vw, 14px);
  color: #7d7d7d;
  padding: 4px 16px;
  cursor: pointer;
  transition: 0.25s;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background: #4d4d4d;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
    color: white;
  }
  &.active {
    background: #4d4d4d;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
    color: white;
  }
}

.grayed {
  background-color: #f4f4f4;
  color: #7d7d7d;
}
.time-select {
  .grayed {
    background-color: #f4f4f4;
    color: #7d7d7d;
    &.white-c-dropdown[data-v-511d4d4c]:not(.no-padding-no-bg){
        background: #f4f4f4;
    }
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
<style lang="scss">
.white-c-dropdown{
  &.dropdown-container .dropdown-initial{
    .white{
      path{
        stroke: hsla(0, 0%, 20%, 1);
      }
    }
  }
}
.time-select {
  .grayed {
     &.dropdown-container .dropdown-initial{
      .white{
        path{
          stroke: rgba(51, 51, 51, 0.425);
        }
      }
    }
  }
}
</style>